import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SimDataDetailsComponent } from './sim-data-details.component';
const routes: Routes = [
  {
    path: 'sim-data-details',
    data: { name: 'SIM Data Details', isTab: false },
    component: SimDataDetailsComponent,
  },
  // {
  //   path: "sim-data-details/:id",
  //   component: SimDataDetailsComponent,
  // }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SimDataDetailsRoutingModule {}
